import {

  CURRENT_USER_REQUEST_ERROR,
  CURRENT_USER_REQUEST_SUCCESS,
  CURRENT_USER_FETCHING,
  IS_GET_API,
  CHOOSE_ROAD_SUCCESS,
  UPDATE_INFO_SUCCESS,
  CHECK_PROGRESS_SUCCESS,
  SHARE_FB_SUCCESS,
  GET_HISTORY_SUCCESS,
  CLAIM_MEDAL_SUCCESS,
  CLAIM_MISSION_SUCCESS,
  CHECK_MISSION_SUCCESS,
  VOTE_TEAM_SUCCESS,
  CLAIM_STAGE_SUCCESS,
  RELOAD_SUCCESS,
} from './actions'

const initialState = {
  loading: false,
  isGetUsser:false,
  login: false,
  user: null,
  current_datetime: null,
  history: null,
  mission: null,
  current_datetime: null,
  promotion_info: null,
}

export default function eventReducer(state = initialState, action) {
  switch (action.type) {
    case CURRENT_USER_REQUEST_SUCCESS:
      return {
        ...state,
        isGetUsser: false,
        login: true,
        user: action.payload.user,
        promotion_info: action.payload.promotion_info,
        current_datetime: action.payload.current_datetime,
      }
      break;
    case CURRENT_USER_REQUEST_ERROR:
      return {
        ...state,
        isGetUsser: false,
        promotion_info: action.payload.promotion_info,
        current_datetime: action.payload.current_datetime,
      }
      break;
    case CURRENT_USER_FETCHING:
      return {
        ...state,
        isGetUsser: true
      }
      break;
    case IS_GET_API:
      return {
        ...state,
        loading: true
      }
      break;
   
    case CLAIM_MISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          ...action.payload.user,
        }
      }
    case CHECK_MISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          ...action.payload.user,
        }
      }
    case RELOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          ...action.payload.user,
        }
      }
    case CLAIM_MEDAL_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          ...action.payload.user,
        }
      }
    case CLAIM_STAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          ...action.payload.user,
        }
      }
    case GET_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        history: action.payload
      }
      break;
    case CHOOSE_ROAD_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          ...action.payload.user,
        }
      }
      break;
    case VOTE_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          ...action.payload.user,
        }
      }
      break;
    case SHARE_FB_SUCCESS:
      return {
        ...state,
        loading: false,
        total_count: action.payload.total_count,
        user: {
          ...state.user,
          ...action.payload.user,
        }
      }
      break;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/Home/modules/reducer.js